import { render, staticRenderFns } from "./SideSubmenuItem.vue?vue&type=template&id=476d2a40&"
import script from "./SideSubmenuItem.vue?vue&type=script&lang=js&"
export * from "./SideSubmenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports